import React from 'react';
import { FadeIn } from './FadeIn';
import { SaladIcon, CarrotIcon, CitrusIcon, LeafIcon, FishIcon, SoupIcon } from 'lucide-react';
export function Allies() {
  const allies = [{
    icon: <SaladIcon className="w-6 h-6 text-[#98c9a3]" data-id="element-19" />,
    bgIcon: 'bg-[#98c9a3]/20',
    title: 'Crucíferas',
    desc: 'Brócoli, kale, coliflor. I3C que limpia el estrógeno malo.'
  }, {
    icon: <CarrotIcon className="w-6 h-6 text-peach" data-id="element-20" />,
    bgIcon: 'bg-peach/20',
    title: 'Carotenoides',
    desc: 'Zanahoria, calabaza. Antioxidantes en el líquido peritoneal.'
  }, {
    icon: <CitrusIcon className="w-6 h-6 text-[#e8c37a]" data-id="element-21" />,
    bgIcon: 'bg-[#e8c37a]/20',
    title: 'Cúrcuma + Jengibre',
    desc: 'Inhiben COX-2 como un analgésico natural. Diarios.'
  }, {
    icon: <LeafIcon className="w-6 h-6 text-[#98c9a3]" data-id="element-22" />,
    bgIcon: 'bg-[#98c9a3]/20',
    title: 'Verdes Oscuros',
    desc: 'Magnesio puro para relajar el útero y calmar calambres.'
  }, {
    icon: <FishIcon className="w-6 h-6 text-[#7ab8e8]" data-id="element-23" />,
    bgIcon: 'bg-[#7ab8e8]/20',
    title: 'Omega-3',
    desc: 'Pescados grasos y semillas para apagar el fuego sistémico.'
  }, {
    icon: <SoupIcon className="w-6 h-6 text-[#e8c37a]" data-id="element-24" />,
    bgIcon: 'bg-[#e8c37a]/20',
    title: 'Caldo de Huesos',
    desc: 'Colágeno y glutamina para sellar la barrera intestinal.'
  }];
  return <section className="py-12 md:py-24 bg-[#1b2f28]" data-id="element-25">
      <FadeIn className="container mx-auto px-5 max-w-[1200px]" data-id="element-26">
        <div className="max-w-3xl mb-10 md:mb-16" data-id="element-27">
          <span className="text-peach text-xs font-bold tracking-[0.2em] uppercase mb-3 md:mb-4 block" data-id="element-28">
            Capítulo 3 · Tus aliados antiinflamatorios
          </span>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-cream mb-4 md:mb-6 leading-tight" data-id="element-29">
            El arcoíris fitoquímico que apaga la inflamación
          </h2>
          <p className="text-sand/90 text-lg md:text-xl leading-relaxed max-w-2xl" data-id="element-30">
            Cada color en tu plato tiene una función biológica específica. No se
            trata de comer "más lechuga", sino de elegir estratégicamente lo que
            apaga las rutas del dolor.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-31">
          {allies.map((ally, idx) => <div key={idx} className="bg-gradient-to-br from-[#233831] to-[#1b2f28] border border-cream/5 rounded-2xl p-6 md:p-8 shadow-lg hover:border-cream/10 transition-colors" data-id="element-32">
              <div className={`w-14 h-14 rounded-2xl ${ally.bgIcon} flex items-center justify-center mb-5 md:mb-6`} data-id="element-33">
                {ally.icon}
              </div>
              <h3 className="font-serif text-2xl text-cream mb-3" data-id="element-34">
                {ally.title}
              </h3>
              <p className="text-sand/80 leading-relaxed" data-id="element-35">{ally.desc}</p>
            </div>)}
        </div>
      </FadeIn>
    </section>;
}